import axios from "axios";
import { API_PERU_URL, API_PERU_TOKEN } from "../../config/configEnvs";

const capitalizeInitials = (str) =>
  str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const formatWorkerNameFromDni = (nombreCompleto) => {
  const partes = nombreCompleto.trim().split(" ");
  const nombre = partes.slice(-2).join(" ");
  return capitalizeInitials(nombre);
};

const FetchDNI = async ({ dni, loadingSetter = null }) => {
  if (loadingSetter) loadingSetter(true);

  try {
    if (!dni || dni.length !== 8) {
      return false;
    }

    const response = await axios.post(
      `${API_PERU_URL}dni`,
      { dni },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_PERU_TOKEN}`,
        },
      }
    );

    const payload = response.data?.data;
    if (!response.data?.success || !payload?.nombre_completo) {
      return false;
    }

    return payload.nombre_completo;
  } catch (e) {
    return false;
  } finally {
    if (loadingSetter) loadingSetter(false);
  }
};

export default FetchDNI;
